export default __webpack_public_path__ + "static/media/circle-5.3bfd00d1.svg";